import { createError } from '../error';

class Product {
  constructor(data) {
    data = data || {};
    this.id = data.id;
    if (!this.id) {
      throw createError({
        name: "NoIDProvided",
        message: "Please provide ID for creating product",
      });
    }
    this.name = data.name || null;
    this.active = data.active || null;
    this.location_variables = data.location_variables || [];
    this.role_variables = data.role_variables || [];
    this.locations = data.locations || [];
  }

  get isProductInstance() {
    return true;
  }

  get isForm() {
    return false;
  }

  get hasLocationVariables() {
    return this.location_variables.length > 0;
  }

  get hasRoleVariables() {
    return this.role_variables.length > 0;
  }

  get hasLocations() {
    return this.locations.length > 0;
  }
}

export default Product;
